import { gql } from '@apollo/client'

export const BOUNDING_BOXES_FRAGMENT = gql`
  fragment BoundingBoxes on BoundingBoxSet {
    id
    created
    modified
    verified
    verifiedBy {
      id
      firstName
      lastName
      email
    }
    verifiedDate
    boundingBoxes {
      id
      label
      elDoradoId
      confidence
      coordinates {
        minX
        maxX
        minY
        maxY
      }
      verified
    }
  }
`
